// extracted by mini-css-extract-plugin
module.exports = {"layout":"tabs_layout__A2sFs","header":"tabs_header__2PFKO","active":"tabs_active__3ZPTt"};